import type { ExcelAddinSkinDefinition } from "../types"
import { CREDITHQ_DARK_PALETTE, CREDITHQ_LIGHT_PALETTE } from "./palettes"

export const credithqSkin: ExcelAddinSkinDefinition = {
	id: "credithq",
	brandQueryValue: "credithq",
	manifest: { dev: "manifest-credithq.xml", prod: "prod-manifest-credithq.xml" },
	features: { themeBuilderPage: false, showPrimaryNavPages: false },
	lockedTheme: {
		light: CREDITHQ_LIGHT_PALETTE,
		dark: CREDITHQ_DARK_PALETTE,
		darkModeSurfaces: {
			page: "#0f172a",
			surface: "#1e293b",
			elevated: "#334155",
		},
	},
	ui: {
		displayName: "CreditHQ",
		shortName: "CreditHQ",
		datasetBrand: "credithq",
		logoUrl: "assets/credithq-mark.jpg",
		logoAlt: "CreditHQ",
		menuRootAriaLabel: "CreditHQ menu",
		menuTriggerAriaLabel: "Open CreditHQ menu",
		signInProductName: "CreditHQ",
		signInCardTitle: "Sign in to CreditHQ",
		refreshFormulasIdle: "Refresh CreditHQ formulas",
		refreshFormulasLoading: "Refreshing…",
		refreshFormulasDone: "Up to date",
		refreshFormulasError: "Refresh failed",
		darkThemeSwitchLabel: "Dark theme",
		formulaNamespaceHint: "AIA",
	},
}
